import { useToast } from '../composables/useToast';

const NETWORK_ERROR_MESSAGE = 'Нет связи с сервером. Проверьте подключение и попробуйте ещё раз.';

/**
 * Ответы бэкенда: { message, errors? } (контракт bootstrap/app.php, FormRequest) или устаревший { error }.
 * Технический текст axios («Request failed with status code 500») пользователю не показывается.
 */
export const extractErrorMessage = (error, fallback = 'Не удалось выполнить действие') => {
    const data = error?.response?.data;
    const serverMessage = data?.error || data?.message;
    if (typeof serverMessage === 'string' && serverMessage !== '') return serverMessage;
    if (error?.isAxiosError && !error.response) return NETWORK_ERROR_MESSAGE;
    return fallback;
};

/**
 * @returns {Record<string, string>} первое сообщение по каждому полю; ключи вида `advertiser_ids.3` сводятся к `advertiser_ids`
 */
export const extractFieldErrors = (error) => {
    const errors = error?.response?.data?.errors;
    if (!errors || typeof errors !== 'object') return {};

    return Object.entries(errors).reduce((result, [key, messages]) => {
        const parts = key.split('.');
        const field = parts.length > 1 && Number.isNaN(Number(parts[1])) ? key : parts[0];
        if (!result[field]) result[field] = Array.isArray(messages) ? messages[0] : String(messages);
        return result;
    }, {});
};

/**
 * Тост с сообщением об ошибке запроса; для 422 добавляет первую ошибку поля, если общий текст неинформативен.
 */
export const notifyHttpError = (error, fallback) => {
    const fieldMessages = Object.values(extractFieldErrors(error));
    const message = extractErrorMessage(error, fallback);
    const isGenericValidation = error?.response?.status === 422 && fieldMessages.length > 0;

    useToast().error(isGenericValidation && !message.includes(fieldMessages[0]) ? `${message}\n${fieldMessages[0]}` : message);
};
